<ion-header>
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="10">
                <ion-title class="ion-text-wrap" style="padding: 0 4px; text-align: left;">{{title}}</ion-title>

            </ion-col>
            <ion-col size="2">
                <ion-buttons>
                    <ion-button fill="clear" (click)="dismiss()">
                        <ion-icon name="close"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div style="padding:15px">
        {{desc}}
        <br>
        <p style="cursor:pointer" *ngIf="testimony_notification" (click)="NavigateToTestimony()">{{'ViewTestimony' | translation}}</p>
        <p style="cursor:pointer" *ngIf="chat_notification" (click)="NavigateToChat()">{{'ViewChat' | translation}}</p>
    </div>
</ion-content>